import {
  RequiredField,
  Table,
  Quantity,
  FibreList,
  CatalogueTable,
} from "../Constants/GlobalConstant";
import check_mask from "./MaskValidation";
import onBarCodeBlur, { computeBarcodeWithCheckDigit } from "./BarCodeFun";
import { getMessage } from "./messages";
import { meetsCondition } from "./ConditionalValidation";

export const schemaValidation = (
  values,
  schemaForm,
  mandatoryByLabelName,
  mapTableItemID,
  selectedOption,
  tableItemID,
  selectedTabs,
  csvUplaodEnabled
) => {
  let errors = {};
  for (let schema of schemaForm) {
    if (
      (schema.itemId,
      !tableItemID?.includes(schema.itemId?.toString()) ||
        schema.itemId.toString() === mapTableItemID?.toString())
    ) {
      if (!csvUplaodEnabled) {
        validate(
          values,
          schema,
          errors,
          mandatoryByLabelName,
          mapTableItemID,
          selectedOption,
          tableItemID
        );
      } else {
        if (selectedTabs.includes(schema.tabValue.toString())) {
          validate(
            values,
            schema,
            errors,
            mandatoryByLabelName,
            mapTableItemID,
            selectedOption,
            tableItemID
          );
        }
      }
    }
  }
  return errors;
};

function validate(values, schema, errors, mandatoryByLabelName) {
  if (schema.dataType != Table && schema.dataType != CatalogueTable) {
    validateSchema(
      schema,
      errors,
      values[schema.fieldName],
      mandatoryByLabelName,
      false
    );
    //}
  } else if (schema.dataType === Table || schema.dataType === CatalogueTable) {
    //if (schema.prefix !== "STI" && schema.prefix !== "STC") {

    let isFill = false;
    const checkBoxSchema = schema.schemaPageSubItems.find(
      (x) => x.prefix === "CHK"
    );
    const staticSchema = schema.schemaPageSubItems.find(
      (x) => x.prefix === "STC" && x.display === false
    );
    if (values[schema.fieldName]) {
      values[schema.fieldName].forEach((rowValue, i) => {
        if (
          Object.values(rowValue).some(
            (x) =>
              x?.length > 0 &&
              x !== rowValue[checkBoxSchema?.fieldName] &&
              x !== rowValue[staticSchema?.fieldName]
          )
        ) {
          let error = {};
          isFill = true;
          for (const [key, value] of Object.entries(rowValue)) {
            let schemaData = schema.schemaPageSubItems.find(
              (x) => x.fieldName == key
            );

            if (schemaData) {
              validateSchema(
                schemaData,
                error,
                value,
                mandatoryByLabelName,
                true
              );
            }
          }
          if (JSON.stringify(error) != "{}") {
            error.index = i;
            if (!errors[schema.fieldName]) errors[schema.fieldName] = [];
            errors[schema.fieldName].push(error);
          }
        }
      });
    }
    if (
      !isFill &&
      schema?.schemaPageSubItems?.some((x) => x?.validation?.mandatory == true)
    )
      errors[schema.fieldName + "_" + "Label"] =
        getMessage("tableRowValidation");
    //"* At least one row  should be filled";
  }
}

function validateSchema(
  {
    dataType,
    fieldName,
    validation,
    type,
    calculation,
    size,
    prefix,
    catalogueSchemaType,
  },
  error,
  value,
  mandatoryByLabelName,
  labelInsideTable
) {
  if (validation && prefix !== "STI" && prefix !== "STC") {
    // Barcode auto-fix before any validation (compute check digit / leading zero if required)
    if (dataType === "Barcode" && value) {
      const computed = computeBarcodeWithCheckDigit(value, type, calculation, size);
      if (computed && computed !== value) {
        value = computed;
      }
      const barcodeError = onBarCodeBlur(value, type, calculation, size);
      if (barcodeError) {
        error[fieldName] = barcodeError;
        // If barcode format invalid, stop further validations on this field
        return;
      }
    }

    if (prefix === "LAB" && !value && labelInsideTable) {
      error[fieldName] = RequiredField;
    } else if (validation.mandatory && !value) {
      error[fieldName] = RequiredField;
    } else if (
      mandatoryByLabelName &&
      validation.mandatoryByLabelName === mandatoryByLabelName &&
      !value
    ) {
      error[fieldName] = RequiredField;
    } else if (dataType == Quantity || catalogueSchemaType == 16) {
      const num = Number(value);
      if (Number.isNaN(num)) {
        error[fieldName] = RequiredField;
      } else {
        if (meetsCondition(num, validation)) {
          if (validation?.minValue !== undefined && num < Number(validation.minValue)) {
            error[fieldName] = `The Min Values is ${validation.minValue}`;
          } else if (validation?.maxValue !== undefined && num > Number(validation.maxValue)) {
            error[fieldName] = `The Max Values is ${validation.maxValue}`;
          } else if (num > 2147483647) {
            error[fieldName] = `The Max Values is 2147483647`;
          }
        }
      }
    } else if (
      validation.pictureMask &&
      value &&
      !check_mask(value, validation.pictureMask.replace(/"/g, "")).isValid
    ) {
      error[fieldName] =
        getMessage("incorrectFormat") +
        "(" +
        validation.pictureMask.replace(/"/g, "") +
        ")";
    }

    if (dataType === FibreList) {
      const garmentFibres = value;
      if (garmentFibres) {
        if (garmentFibres.every((x) => !x.isSave && validation.mandatory)) {
          error[fieldName] = getMessage("fiberValidation");
        } else if (
          garmentFibres.some((x) => x.garment?.garment?.length > 0 && !x.isSave)
        ) {
          error[fieldName] = getMessage("fiberSubmitValidation");
        }
      }
    }
  }
}

export function resetLinkedList(
  schemaResult,
  pageId,
  schemaItem,
  values,
  setFieldValue
) {
  schemaResult?.forEach((x) => {
    if (x.dataType == Table) {
      let items = [];
      getItems(x, pageId, schemaItem, items);
      let tableSchema = values[x.fieldName];
      for (let item of items) {
        tableSchema?.forEach((row, rowIndex) => {
          if (row[item]?.length > 0) {
            setFieldValue(`${x.fieldName}[${rowIndex}].${item}`, "");
          }
        });
      }
    } else {
      if (x.prefix === "ELC" && x.parentId  === pageId + "|" + schemaItem) {
        setFieldValue(x.fieldName, "");
        resetLinkedList(schemaResult, x.pageId, x.schemaItem, values, setFieldValue)
      }
    }
  });
}

export function resetChildLinkedList(
  tableObj,
  pageId,
  schemaItem,
  values,
  index,
  setFieldValue
) {
  let items = [];
  getItems(tableObj, pageId, schemaItem, items);
  let tableSchema = values[tableObj.tableName]?.[index];
  if (tableSchema) {
    for (let item of items) {
      if (tableSchema[item]?.length > 0) tableSchema[item] = "";
    }
    //setFieldValue(`${tableObj.tableName}[${index}]`, tableSchema);
  }
}

//reset dropdown value based on LLI changes
export function resetList(childPageId, childItemId, schemaResult, values) {
  var childData = schemaResult?.find((x) => x.itemId === childPageId);
  if (childData) {
    var schemaSubFieldName = childData.schemaPageSubItems?.find(
      (x) => x.schemaItem === childItemId
    )?.fieldName;
    var formValue = values[childData.fieldName];
    formValue?.forEach((x) => {
      if (x[schemaSubFieldName]?.length > 0) x[schemaSubFieldName] = "";
    });
  }
}

export function getItems(tableSchema, pageId, schemaItem, items) {
  // const schemaSets = tableSchema?.schemaPageSubItems?.filter((x) =>
  //   getParentId(x, pageId, schemaItem)
  // );
  const schemaSets = tableSchema?.schemaPageSubItems?.filter(
    (schema) =>
      schema.dataType === "Linked Child List" &&
      schema?.parentId == pageId + "|" + schemaItem
  );
  if (!schemaSets || schemaSets.length == 0) return;
  for (let schema of schemaSets) {
    if (schema) items?.push(schema.fieldName);
    getItems(tableSchema, schema?.pageId, schema?.schemaItem, items);
  }
}

export function getLabelAndValue(dropDownValue) {
  if (dropDownValue?.includes("|")) return dropDownValue?.split("|");
  return [dropDownValue];
}

export const processString = (value) => {
  // Check if the value contains a pattern with brackets
  const match = value?.match(/^\[(.*?)\](.*)$/);

  if (match) {
    // Extract the code and the remaining text
    const code = match[1];
    const text = match[2].trim();
    return { code, text };
  } else {
    // If no pattern is found, return the whole string as text
    return { code: "", text: value?.trim() };
  }
};

export function checkGarmentpercentage(
  garment,
  garmentIndex,
  mandatoryGarmentPart
) {
  let garmentPercentage = 0;
  const fibres = Array.isArray(garment?.fibres) ? garment.fibres : [];

  if (fibres.length > 0) {
    const seen = new Set();
    for (const fibre of fibres) {
      if (fibre.fibre) {
        if (seen.has(fibre.fibre)) {
          return [garmentPercentage, false, "Duplicate fibres are not allowed"];
        }
        seen.add(fibre.fibre);
      }
    }
  }
  const garments = Array.isArray(garment?.garment) ? garment.garment : [];

  if (fibres.length > 0) {
    for (const fibre of fibres) {
      if (!fibre.fibre && !(garmentIndex > 0)) {
        return [
          fibre.percentage,
          false,
          "Please select garment fibre and percentage",
        ];
      }
      garmentPercentage += Number(fibre.percentage) || 0;
    }
  }
  if (garments.length > 0) {
    if (mandatoryGarmentPart || (!mandatoryGarmentPart && garmentIndex > 0)) {
      for (const garment2 of garments) {
        if (!garment2.garment) {
          return [0, false, "Please select garment component"];
        }
      }
    }
  }
  const roundedPercentage = Math.round(garmentPercentage * 100) / 100;
  const noFibreSelected = fibres.every((f) => !f.fibre);
  const allFibreSelected = fibres.every((f) => f.fibre);

  if (
    garmentIndex !== 0 &&
    roundedPercentage === 0 &&
    fibres.length > 0 &&
    noFibreSelected
  ) {
    return [0, true, "Garment Component saved successfully"];
  }

  if (
    roundedPercentage === 100 &&
    fibres.length > 0 &&
    allFibreSelected &&
    garments.length > 0
  ) {
    return [roundedPercentage, true, "Garment Component saved successfully"];
  }

  return [
    roundedPercentage,
    false,
    "Garment Component should be filled with 100 percent",
  ];
}
export function getDataType(schema, fieldName) {
  return schema?.find((x) => x.fieldName === fieldName)?.dataType;
}

export function convertTextToTitleCase(inputText) {
  let camelCaseText = inputText
    .split(" ")
    .map(function (word, index) {
      // First character upper case else lower case
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");

  return camelCaseText;
}
export function atLeastOneNull(arr) {
  return arr.some((element) => element === null);
}
export function titleCase(str) {
  return str
}
